import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import httpClient from '../../../http/HttpRequest';
import { GET_LOGO } from '../../../data/url';

const LogoContext = createContext();

export const useLogoContext = () => {
     return useContext(LogoContext);
};

export const LogoProvider = ({ children }) => {
     const [logo, setLogo] = useState({});

     const getLogo = useCallback(async () => {
          try {
               const res = await httpClient.post(GET_LOGO, {});
               if (res.requestStatus === 'OK' && res.result.status === 1) {
                    setLogo(res.result.data);
               }
          } catch (error) {
               console.error('Logo API error:', error);
          }
     }, []);

     useEffect(() => {
          getLogo();
     }, [getLogo]);

     return (
          <LogoContext.Provider value={{ logo }}>
               {children}
          </LogoContext.Provider>
     );
};
